import { Outlet } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import { ScrollProvider } from './context/ScrollContext';

function App() {
  return (
    <ScrollProvider>
      <div className="w-full min-h-full flex flex-col text-center">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </ScrollProvider>
  );
}

export default App;
